import { render } from "./SearchForm.vue?vue&type=template&id=59c0065d&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=59c0065d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59c0065d"

export default script